export const getCookieByName = (name: string) => {
  const pattern = '(^|;)\\s*' + name + '\\s*=\\s*([^;]+)'
  const match = document.cookie.match(new RegExp(pattern))

  return match && match[2] ? decodeURIComponent(match[2]) : undefined
}
